import React from 'react';
import { Card, Tag, Space, Avatar, Typography } from 'antd';
import {
  EyeOutlined,
  LikeOutlined,
  MessageOutlined,
  CalendarOutlined,
  UserOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import './index.css';

const { Title, Paragraph } = Typography;
const { Meta } = Card;

const PostCard = ({ post }) => {
  const {
    id,
    title,
    summary,
    coverImage,
    author,
    tags,
    viewCount,
    likeCount,
    commentCount,
    createdAt,
    category
  } = post;

  return (
    <Card
      className="post-card"
      hoverable
      cover={
        coverImage ? (
          <div className="post-cover">
            <img
              alt={title}
              src={coverImage}
              className="cover-image"
            />
            <div className="category-tag">{category}</div>
          </div>
        ) : null
      }
      actions={[
        <Space key="views" className="card-action">
          <EyeOutlined />
          <span>{viewCount}</span>
        </Space>,
        <Space key="likes" className="card-action">
          <LikeOutlined />
          <span>{likeCount}</span>
        </Space>,
        <Space key="comments" className="card-action">
          <MessageOutlined />
          <span>{commentCount}</span>
        </Space>
      ]}
    >
      <Meta
        title={
          <Link to={`/post/${id}`} className="post-title-link">
            <Title level={4} className="post-title">
              {title}
            </Title>
          </Link>
        }
        description={
          <div className="post-meta">
            {/* 作者和时间 */}
            <div className="post-info">
              <Space size="middle">
                <Space size="small">
                  <Avatar size="small" icon={<UserOutlined />} />
                  <span className="author-name">{author}</span>
                </Space>
                <Space size="small">
                  <CalendarOutlined className="info-icon" />
                  <span className="date-text">
                    {dayjs(createdAt).format('YYYY-MM-DD')}
                  </span>
                </Space>
              </Space>
            </div>
            
            {/* 文章摘要 */}
            <Paragraph className="post-summary" ellipsis={{ rows: 2 }}>
              {summary}
            </Paragraph>
            
            {/* 标签 */}
            <div className="post-tags">
              {tags.slice(0, 3).map(tag => (
                <Tag key={tag} color="blue" className="post-tag">
                  {tag}
                </Tag>
              ))}
              {tags.length > 3 && (
                <Tag color="default" className="post-tag">
                  +{tags.length - 3}
                </Tag>
              )}
            </div>
          </div>
        }
      />
    </Card>
  );
};

export default PostCard;